import {Component, Input, OnInit, inject} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormGroupDirective, FormsModule,
  ReactiveFormsModule, Validators,
} from '@angular/forms';

import {OutlineButtonComponent} from "../../../../shared/ui/outline-button/outline-button.component";
import {faAdd, faBars, faChevronDown, faChevronUp, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {TabStepperComponent} from "../../../ui/tab-container/tab-container.component";
import {CdkStepperModule} from "@angular/cdk/stepper";
import {AssessmentQuestionsComponent} from "./assessment-questions/assessment-questions.component";
import {ContentService} from "../../../../admin/data-access/content.service";
import { DropdownSearchComponent } from 'src/app/shared/ui/dropdown-search/dropdown-search.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatInputModule} from "@angular/material/input";
import _ from "lodash";
import {LearningObjective} from "../../../../admin/feature/contentViewer/learningObjective/learningObjective.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from '@angular/router';
import {QuillEditorComponent} from "ngx-quill";
import {FullButtonComponent} from "../../../../shared/ui/full-button/full-button.component";
import { DeleteConfirmationComponent } from "src/app/shared/ui/delete-confirmation/delete-confirmation.component";
import {ExamService} from "../../../data-access/exam.service";

// NOTE: Assessment is equivalent to part in this context
export interface Assessment {
  title: string
  instructions: string
  expanded: boolean
  time: number
  noTime: boolean
  linear: boolean
  questionPoolsIDs: number[]
  addedSubjects: Subject[]
  addedCCLs: CCL[]
  questionPools: Pools[]
}
export interface Pools {
  total_score: number
  examqpool_id: number
  exampart_id: number
  qpool_position: number
  presentation_order: string
  questions_used: number
  score_per_question: number
  questions: Question[]
  expanded: boolean
}
export interface Question {
  problemtemplate_id: number
  value: number
  addedProblemTemplate: ProblemTemplate[]
}
export interface ProblemTemplate {
  customcontentlayer_id: number
  learningobjective_name: string
  problemtemplate_id: number
  name: string
  learningobjective_id: number
  is_static: boolean
  answer_type: string
}
export interface Subject {
  subject_id: number
  name: string
  customcontentlayer_id?: number;
}
export interface CCL {
  subject_id: number
  customcontentlayer_children: number
  learningobjective_children: number
  customcontentlayer_id: number
  name: string
  active: boolean
  createdate: Date
  last_updated: Date
}
interface SubCCL extends CCL {
  parent_customcontentlayer_id: number
}
@Component({
    selector: 'app-exam-construct',
    templateUrl: './construct.component.html',
    styleUrls: ['./construct.component.css', '../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css'],
  imports: [ReactiveFormsModule, OutlineButtonComponent, FontAwesomeModule, TabStepperComponent, CdkStepperModule, FormsModule, AssessmentQuestionsComponent, DropdownSearchComponent, MatCheckboxModule, MatInputModule, QuillEditorComponent, FullButtonComponent, DeleteConfirmationComponent]
})
export class ConstructComponent implements OnInit {

  constructor(private contentService: ContentService, private _snackBar: MatSnackBar, private route: ActivatedRoute) {}

  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'align': [] }],

      ['clean'],                                         // remove formatting button

      ['link']                                          // link
    ]
  };

  @Input() formGroupName!: string;
  constructFormSection!: FormGroup;
  faAdd = faAdd
  faChevronDown = faChevronDown
  faChevronUp = faChevronUp

  router = inject(Router);
  examService = inject(ExamService);
  rootFormGroup = inject(FormGroupDirective);
  mobile = false
  addedAssessmentList: Assessment[] = []
  allSubjects: Subject[] = []
  allSubjectsAdded: Subject[] = []
  allSubjectsLoading = false
  assessmentQuestionPoolsIDs: number[] = []
  allCCLs: CCL[] = []
  allAddedCCLs: CCL[] = []
  selectedSubjectID = -1
  selectedCCLID = -1
  partIter = 0

  questionPools: Pools[] = []
  allProblemTemplates: ProblemTemplate[] = []

  selectedSubjects: Subject[] = [];
  selectedCCLs: CCL[] = []

  allLearningObjective: LearningObjective[] = [];
  addedLearningObjective: LearningObjective[] = []
  allSubCCLs: SubCCL[] = []
  addedSubCCLs: SubCCL[] = []

  ngOnInit(): void {
    if (window.screen.width <= 820) { // 768px portrait
      this.mobile = true;
    }
    this.constructFormSection = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;

    this.allSubjectsLoading = true

    this.route.queryParams.subscribe(params => {
      if (!params['edit'] && !params['clone']) {
        this.addParts()
      }
      if(params['exam_id']) {
        this.examService.getExamContent(params['exam_id']).subscribe((response) => {
          for(let subject of response.result.subjects) {
            this.allSubjectsAdded.push({
              subject_id: subject.subject_id,
              name: subject.name
            })
          }
          this.contentService.getAllSubjects().subscribe((response) => {
            if(response.success) {
              for(let subject of response.result) {
                this.allSubjects.push(subject)
              }
              //this.allSubjects = response.result
            } else {

            }
            this.allSubjectsLoading = false
          });
          for(let learningObject of response.result.learningObjectives) {
            this.addedLearningObjective.push({
              name: learningObject.name,
              learningobjective_id: learningObject.learningobjective_id,
              subject_id: -1,
              problemtemplate_count: learningObject.problem_templates,
              createdate: learningObject.createdate,
              last_updated: learningObject.last_updated
            })
          }
          for(let learningObject of response.result.allLearningObjectives) {
            this.allLearningObjective.push({
              name: learningObject.name,
              learningobjective_id: learningObject.learningobjective_id,
              subject_id: -1,
              problemtemplate_count: learningObject.problem_templates,
              createdate: learningObject.createdate,
              last_updated: learningObject.last_updated,
            })
          }
        })
      } else {
        this.contentService.getAllSubjects().subscribe((response) => {
          if(response.success) {
            this.allSubjects = response.result
          } else {

          }
          this.allSubjectsLoading = false
        });
      }
    });
  }

  get general(): FormGroup {
    return this.constructFormSection.get('general') as FormGroup;
  }

  get parts(): FormArray {
    return this.general.get('parts') as FormArray;
  }

  // TODO might need to have a child component for question pools and questions cause of the way forms work
  qpools: FormArray = new FormArray<any>([])

  addParts() {
    this.addedAssessmentList.push({
      title: 'Untitled Assignment',
      instructions: '',
      expanded: false,
      time: 0,
      noTime: false,
      linear: true,
      questionPoolsIDs: [],
      addedSubjects: [],
      addedCCLs: [],
      questionPools: []
    })
    let entrypoint = false
    if(this.parts.getRawValue().length === 0)
      entrypoint = true
    const partsForm = new FormGroup({
      part_name: new FormControl('Untitled Part', Validators.required),
      part_instructions: new FormControl(''),
      part_duration_minutes: new FormControl(null),
      unconditional_next_part: new FormControl(null),
      entrypoint: new FormControl(entrypoint),
      expanded: new FormControl(true),
      // TODO for editing of an exam need to fill exam_id with the right id
      exam_id: new FormControl(null),
      exampart_id: new FormControl(this.partIter * -1),
      qpools: new FormArray([])
    });
    this.parts.push(partsForm);
    if(this.parts.length > 1) {
      this.parts.controls[this.parts.length-2].get('unconditional_next_part')?.setValue(Math.abs(this.parts.length-1) * -1, { emitEvent: true })
    }
    this.partIter += 1
  }

  getSubjectChildren(subject_id: number) {
    this.selectedSubjects = [...this.allSubjectsAdded];
    if(this.assessmentQuestionPoolsIDs.indexOf(subject_id) === -1) {
      this.assessmentQuestionPoolsIDs.push(subject_id)
    }

    this.contentService.listCCLChildren(subject_id, -1).subscribe((response) => {
      if(response.success) {
        this.allCCLs = response.result
      } else if(response.msg === "no custom content layers found") {
        let tempIds: number[] = []
        for(let subject of this.selectedSubjects) {
          tempIds.push(subject.subject_id)
        }
        this.listPTsByIDs(tempIds)
      }
    })
  }

  getCCLChildren(ccl_id: number) {
    this.contentService.listCCLChildren(-1, ccl_id).subscribe((response) => {
      if(response.success) {
        for(let ccl of response.result) {
          if(!this.allSubCCLs.some(obj => obj.customcontentlayer_id === ccl.customcontentlayer_id)) {
            this.allSubCCLs.push({
              ...ccl,
              parent_customcontentlayer_id: ccl_id
            })
          }
        }
      } else if(response.msg === 'no custom content layers found') {
        this.contentService.getLearningObjList('', ccl_id.toString(), 0, -1).subscribe((response) => {
          if(response.success) {
            this.makeAllLearningObjectiveList(response.result.items, ccl_id)
          }
        })
      }
    })
  }

  makeAllLearningObjectiveList(items: any[], ccl_id: number) {
    for(let item of items) {
      if(!this.allLearningObjective.some(el => el.learningobjective_id === item.learningobjective_id)) {
        this.allLearningObjective.push({
          ...item,
          ccl_id: ccl_id
        })
      }
    }
}

  listPTsByIDs(IDs: number[]) {
    for(let id of IDs) {
      // TODO need to handle both ccls and LOs better
      this.contentService.getLearningObjList(id.toString(), '', 0, -1).subscribe((response) =>{
        if(response.success) {
          for(let item of response.result.items) {
            if(!this.allLearningObjective.some(el => el.learningobjective_id === item.learningobjective_id)) {
              this.allLearningObjective.push({
                ...item,
                subject_id: id
              })
            }
          }
        } else {
          this.allLearningObjective = []
        }
      })
    }
  }

  removeAddedSubject(index: number) {
    const deletedSubjectID = this.allSubjectsAdded[index].subject_id
    this.allSubjectsAdded.splice(index, 1);
    this.selectedSubjects = [...this.allSubjectsAdded];
    this.allCCLs.splice(_.indexOf(this.allCCLs, _.find(this.allCCLs, {subject_id: deletedSubjectID})))
    this.allAddedCCLs.splice(_.indexOf(this.allAddedCCLs, _.find(this.allAddedCCLs, {subject_id: deletedSubjectID})))
    this.allLearningObjective.splice(_.indexOf(this.allLearningObjective, _.find(this.allLearningObjective, {subject_id: deletedSubjectID})))
  }


  removeAddedLO(index: number) {
    const lo_id = this.addedLearningObjective[index].learningobjective_id
    this.addedLearningObjective.splice(index, 1)
    this.allProblemTemplates = this.allProblemTemplates.filter(el => el.learningobjective_id !== lo_id)
  }

  removeAddedCCL(index: number) {
    const ccl_id = this.allAddedCCLs[index].customcontentlayer_id
    this.allAddedCCLs.splice(index, 1)
    this.addedSubCCLs = this.addedSubCCLs.filter(el => {
      if(el.parent_customcontentlayer_id === ccl_id) {
        this.filterLOsAndPTsByID(el.customcontentlayer_id)
      }
      return el.parent_customcontentlayer_id !== ccl_id
    })
    this.allSubCCLs = this.allSubCCLs.filter(el => el.parent_customcontentlayer_id !== ccl_id)
    this.filterLOsAndPTsByID(ccl_id)
  }

  removeAddedSubCCL(index: number) {
    const ccl_id = this.addedSubCCLs[index].customcontentlayer_id
    this.addedSubCCLs.splice(index, 1)
    this.filterLOsAndPTsByID(ccl_id)
  }

  filterLOsAndPTsByID(ccl_id: number) {
    this.allLearningObjective = this.allLearningObjective.filter(el => el.ccl_id !== ccl_id)
    let filteredLOs = this.addedLearningObjective.filter(el => el.ccl_id === ccl_id)
    this.addedLearningObjective = this.addedLearningObjective.filter(el => el.ccl_id !== ccl_id)
    for(let LO of filteredLOs) {
      this.allProblemTemplates = this.allProblemTemplates.filter(el => el.learningobjective_id !== LO.learningobjective_id)
    }
  }


  getProblemTemplates() {
    for(let lo of this.addedLearningObjective) {
      this.contentService.listProblemTemplates(lo.learningobjective_id, 0, -1, "", "", false).subscribe((response) => {
        if(response.success) {
          for(let item of response.result.items) {
            if(!this.allProblemTemplates.some(el => el.problemtemplate_id === item.problemtemplate_id)) {
              this.allProblemTemplates.push(item)
            }
          }
        } else if(response.msg === 'No learningobjectives found') {
          // TODO need to find a way to handle this specific issue
        }
      })
    }
  }

  noTimeClick(partsForm: AbstractControl) {
    if( partsForm.get('part_duration_minutes')?.value != null) {
      partsForm.get('part_duration_minutes')?.setValue(null)
    } else {
      partsForm.get('part_duration_minutes')?.setValue(1)
    }
  }

  entrypointClick(partsArray: AbstractControl[], partValue: any, partIter: number) {
    let i = 0
    if(!partValue) {
      for(let parts of partsArray) {
        if(i===partIter) {
          parts.get('entrypoint')?.setValue(true)
        }
        else
          parts.get('entrypoint')?.setValue(false)
        i++
      }
    } else {
      for(let parts of partsArray) {
        if(i===partIter) {
          parts.get('entrypoint')?.setValue(false)
        }
        i++
      }
    }
  }

  showConfirmRemovePartDialog = false
  removePartIter = -1
  removePartsControl: AbstractControl[] = []

  confirmRemovePart(partIter: number, partsControl: AbstractControl[]) {
    console.log('confirm')
    this.showConfirmRemovePartDialog = true
    this.removePartIter = partIter
    this.removePartsControl = partsControl
  }

  removePart(partIter: number, partsControl: AbstractControl[]) {
    if(this.parts.length === 1) {
      this.parts.controls[0].get('unconditional_next_part')?.setValue(null)
    } else if(partIter === this.parts.length-1 && this.parts.length > 1) {
      this.parts.controls[partIter-1].get('unconditional_next_part')?.setValue(null)
    } else if(this.partIter === this.parts.length-1) {
      this.parts.controls[partIter].get('unconditional_next_part')?.setValue(null)
    }
    else if(Number(this.parts.controls[partIter-1].get('unconditional_next_part')?.getRawValue()) > 0) {
      this.parts.controls[partIter-1].get('unconditional_next_part')?.setValue(this.parts.controls[partIter].get('unconditional_next_part')?.getRawValue())
    }
    this.parts.removeAt(partIter)
    if(this.parts.length === 1) {
      this.entrypointClick(partsControl, false, 0)
    }
    this.showConfirmRemovePartDialog = false
  }

  protected readonly FormGroup = FormGroup;
  protected readonly faXmark = faXmark;
}
